import React from 'react';
import { Grid, Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { StyledCheckbox } from '../../Bookings/SetAvailability/SetAvailabilityStep';

interface ConsultationTypeSelectorProps {
  isProvideOnlineConsultations: boolean;
  isProvideInPersonConsultations: boolean;
  setIsProvideOnlineConsultations: (_value: boolean) => void;
  setIsProvideInPersonConsultations: (_value: boolean) => void;
  clearForm: () => void;
  hasPermissions: boolean;
}

const ConsultationTypeSelector: React.FC<ConsultationTypeSelectorProps> = ({
  isProvideOnlineConsultations,
  isProvideInPersonConsultations,
  setIsProvideOnlineConsultations,
  setIsProvideInPersonConsultations,
  clearForm,
  hasPermissions,
}) => {
  const { t } = useTranslation();

  return (
    <Grid maxWidth={400}>
      <Typography variant="title1Bold" fontSize={14} mb={4} ml={2} mr={2}>
        {t('bookings.consultationType')}
      </Typography>
      <Grid display="flex" flexDirection="row" alignItems="center" ml={1} mr={2}>
        <StyledCheckbox
          inputProps={{ 'aria-label': 'controlled' }}
          onClick={() => setIsProvideOnlineConsultations(!isProvideOnlineConsultations)}
          checked={isProvideOnlineConsultations}
          checkedIcon={
            <Box component="img" src="/assets/icons/check-box-checked.svg" width={20} height={20} />
          }
          icon={<Box component="img" src="/assets/icons/check-box.svg" width={20} height={20} />}
          disabled={!hasPermissions}
        />
        <Typography variant="meta" color="primary">
          {t('bookings.steps.onlineConsultations')}
        </Typography>
      </Grid>
      <Grid display="flex" flexDirection="row" alignItems="center" ml={1} mr={2}>
        <StyledCheckbox
          inputProps={{ 'aria-label': 'controlled' }}
          onClick={() => {
            if (isProvideInPersonConsultations) {
              clearForm();
            }
            setIsProvideInPersonConsultations(!isProvideInPersonConsultations);
          }}
          checked={isProvideInPersonConsultations}
          checkedIcon={
            <Box component="img" src="/assets/icons/check-box-checked.svg" width={20} height={20} />
          }
          icon={<Box component="img" src="/assets/icons/check-box.svg" width={20} height={20} />}
          disabled={!hasPermissions}
        />
        <Typography variant="meta" color="primary">
          {t('bookings.steps.inPersonConsultations')}
        </Typography>
      </Grid>
    </Grid>
  );
};

export default ConsultationTypeSelector;
